import(/* webpackMode: "eager", webpackExports: ["MarketingFooter"] */ "/vercel/path0/components/layout/marketing-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingNavbar"] */ "/vercel/path0/components/layout/marketing-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GeometricBackground"] */ "/vercel/path0/components/ui/geometric-background.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
